const MFERuntime = {
  // eslint-disable-next-line no-unused-vars
  install(app, options) {
    console.info('MFE Runtime Initialized');
  },
};

export default MFERuntime;